import { useMutation } from '@tanstack/react-query';

import { endpoints } from 'global/endpoints';
import http from 'utils/http';

export interface IDeleteBreak {
  break_ids: number[];
}

const deleteBreaks = (postData: IDeleteBreak) => {
  return http().delete(endpoints.breaks.deleteBreak, postData);
};

export function useDeleteBreaks() {
  return useMutation({ mutationFn: deleteBreaks });
}
